
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import * as Common from '@/api/common'
import { AnswerType, FeedStatus } from '@/utils/const'
import { getFileName, htmlDecode } from '@/utils/helpers'

import RobotMsgTmpl from '@/components/robot-msg-tmpl.vue'
import AnswerMsg from '@/components/answer-msg.vue'
import UnsolvedReason from '@/components/unsolved-reason.vue'
import TtsAudio from '@/components/tts-audio.vue'

@Component({
  components: {
    RobotMsgTmpl,
    AnswerMsg,
    UnsolvedReason,
    TtsAudio
  }
})
export default class RobotMsg extends Vue {
  @Prop()
  message!: Array<any>

  @Prop()
  commonInfo!: any

  @Prop({ type: Boolean, default: true })
  showFeedback!: boolean

  @Prop({ type: Boolean, default: true })
  showTts!: boolean

  @Prop({ type: Boolean, default: false })
  showManual!: boolean

  @Prop({ type: Boolean, default: true })
  showFileName!: boolean

  @Prop({ type: String, default: '' })
  robotImg!: string

  @Ref('unsolvedReason')
  readonly unsolvedReason!: UnsolvedReason
  
  FeedStatus = FeedStatus
  // -1:未解决，0：没有反馈，1：已解决
  feedback = 0
  loading = false

  previewImg (src: string) {
    this.$emit('previewImg', src)
  }

  imgAllLoad () {
    this.$emit('imgAllLoad')
  }

  solved (obj: any) {
    // 表示已评价过
    if (this.feedback !== 0) {
      return
    }
    this.loading = true

    const params = {
      answerTime: this.commonInfo.answerStamp,
      channelId: this.commonInfo.channelId,
      knowledgeId: this.commonInfo.knowledgeId,
      talkId: this.commonInfo.talkId
    }
    Common.saveSolved(params).then(res => {
      const message: any = this.$t('feedback')
      this.$message.success(message)
      this.loading = false
      this.feedback = FeedStatus.Solved
    }).catch(err => {
      this.loading = false
      const message: any = err.message
      this.$message.error(message)
    })
  }

  unsolved () {
    // 表示已评价过
    if (this.feedback !== 0) {
      return
    }

    this.unsolvedReason.show(this.commonInfo.channelId, this.commonInfo.knowledgeId)
  }

  onSuccess () {
    this.feedback = FeedStatus.Unsolved
  }

  getTtsContent(message: Array<any>) {
    let str = ''
    for (let i = 0, j = message.length; i < j; i++) {
      const item = message[i]
      if ([AnswerType.SinglePic, AnswerType.Audio, AnswerType.Video].includes(item.contentType)) {
        // 单图片、单音频、单视频不进行播报
      } else if ([AnswerType.Attachment].includes(item.contentType)) {
        const fileName = getFileName(item.content)
        str = str + `附件${fileName}`
      } else if ([AnswerType.LinkAnswer].includes(item.contentType)){
        str = str + item.promptGuide
      } else if ([AnswerType.Common].includes(item.contentType)) {
        str = str + htmlDecode(item.content)
      } else {
        str = str + item.content
      }
    }
    return str
  }
}
